import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiAnaconda,
  SiVisualstudiocode,
  SiMongodb,
} from "react-icons/si";

import {
  BiCompass
} from "react-icons/bi";

import {
  DiGit
} from "react-icons/di";


function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiAnaconda />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiVisualstudiocode />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiGit />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <BiCompass />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMongodb />
      </Col>
    </Row>
  );
}

export default Toolstack;
